import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import Collapisble from '../../../../components/Collapsible';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import image from './arts@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="arts">
    <h1>Arts</h1>
    <img src={image} alt="Arts at Kingston" />
    <p>
      The Arts are a powerful mode of communication through which students explore and construct a sense of self and
      develop an understanding of the world around them. Arts provide students with a wide range of opportunities and
      means to respond to their experiences and engage with historical, social and cultural perspectives. The students
      are stimulated to think and to articulate their thoughts in new ways and through a variety of media and
      technologies. Learning about and through Arts is fundamental to the development of the whole child, promoting
      creativity, critical thinking, problem-solving skills and social interactions.
    </p>
    <p>
      At Kingston, students have the opportunity to develop genuine interests, to give careful consideration to their
      work and to become self-critical and reflective. Reflecting on and evaluating their own work and the work of
      others is vital, and empowers students to take intellectual risks. Exposure to and experience with Arts opens
      doors to questions about life and learning. The process of making and appreciating Arts is gratifying and will
      encourage students to continue creating throughout their lives.
    </p>

    <Collapisble trigger="Drama">
      <React.Fragment>
        <p>
          Drama at Kingston explores how we express ourselves physically and vocally. In creating, students explore the
          use of facial expressions, gestures, movement, posture and vocal techniques to convey emotional or cultural
          meaning to both characters and stories. Students are exposed to a variety of dramatic forms including creative
          movement, impersonation, improvisation, mask work, mime, musical, role play, pantomime, puppetry,
          re-enactment, scripted drama, and skit. In responding, students experience a wide variety of scripts and
          stories from different times, cultures and places and, where possible, access live theatre performances and
          presentations. Students have opportunities to present their creative work to audiences, to witness their peers
          in performance and through this become critically aware audience members.
        </p>
      </React.Fragment>
    </Collapisble>

    <Collapisble trigger="Design">
      <React.Fragment>
        <p>
          Design at Kingston is used to describe practices that have been more traditionally described in education as
          "art, craft and design". Students are exposed to a broad range of experiences that illustrate the field of
          visual arts, including architecture, ceramics, collage, costume design, drawing, graphic design, film,
          illustration, industrial design, installation, jewellery, land art, mask making, metal-work, painting,
          papermaking, performance art, photography, printmaking, sculpture, set design, textiles and woodwork.
          Throughout Years 1 - 6 at Kingston, students develop their individuality and collaborative understanding as
          performers, designers, creators and directors.
        </p>
      </React.Fragment>
    </Collapisble>

    <Collapisble trigger="Music">
      <React.Fragment>
        <p>Music in the PYP is divided into two main strands of learning:</p>
        <h4>Creating</h4>
        <p>
          Students use their imagination and musical experiences to organise sounds into various forms that communicate
          specific ideas or moods.
        </p>
        <h4>Responding</h4>
        <p>
          Students are given the opportunity to respond to different styles of music, as well as to music from different
          times and cultures. Individually and collaboratively, students have the opportunity to create and respond to
          music ideas.
        </p>
        <p>
          During their time at Kingston students will have the opportunity to engage in a broad range of music
          experiences including, singing, listening, playing percussion instruments, improvising, composing using
          traditional and graphic notation, body percussion, performing, dancing, harmonising, classifying and analysing
          sounds and recording.
        </p>
        <p>
          The development of listening skills, an important aspect of all learning, is constantly reinforced in music
          classes.
        </p>
      </React.Fragment>
    </Collapisble>

    <Collapisble trigger="Performance">
      <React.Fragment>
        <p>
          All students are involved in a collaborative year group performance once a year. In lower years this involves
          singing with choreographed movements. In year 4 and 5 the students add the challenge of playing pitched and
          unpitched percussion instruments to accompany their own performances. In year 6 the students further their
          performing arts skills by singing in harmony, acting and dancing in a musical production.
        </p>
        <p>
          There are also additional opportunities for interested upper primary students to audition and share their
          musical skills, performing for the Kingston community at events throughout the year.
        </p>
      </React.Fragment>
    </Collapisble>
  </ContentLayout>
);
